module.exports = __webpack_public_path__ + "img/gold-card.3d5a2b53.png";